/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Mon Mar 25 2024
 **/

import { Column, Divider, TabContainer, TabContent, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

import { usePhoneCall } from "@/frameworks/core/hooks";

import { Maybe } from "@/frameworks/libraries";
import * as S from "../../emotion";
import CallHistory from "./CallHistory";
import PeerDetail from "./PeerDetail";
import { hasCallGatewayClient } from "@/modules/phone/utils";

export default function Tabs(props: PushServices.Call.PhoneDetailProps) {
	const phoneCall = usePhoneCall();
	const callees = phoneCall.state.callees[0];
	const isGateWayCallMember = callees.some((callee) =>
		hasCallGatewayClient(callee as SwaggerModels.CallUserResponseVO)
	);

	return (
		<S.TabWrapper horizonAlign="center">
			<Maybe test={Boolean(props.isFromRecent)}>
				<S.TabArea>
					<TabContainer activeId={props.tabID}>
						<S.StyledTab>
							<S.StyledTabItem id="call-history">
								<Typography.p typoSize="Title3">{_T("통화내역")}</Typography.p>
							</S.StyledTabItem>
							{!isGateWayCallMember && (
								<S.StyledTabItem id="more-info">
									<Typography.p typoSize="Title3">{_T("상세정보")}</Typography.p>
								</S.StyledTabItem>
							)}
						</S.StyledTab>
						<TabContent activeId="call-history" style={{ width: "100%", height: "100%" }}>
							<CallHistory callees={callees} />
						</TabContent>
						{!isGateWayCallMember && (
							<TabContent activeId="more-info">
								<PeerDetail callee={callees[0]} />
							</TabContent>
						)}
					</TabContainer>
				</S.TabArea>
				<Maybe.Fallback>
					<Column css={{ width: "100%" }}>
						<Divider type="line" />
						<PeerDetail callee={callees[0]} />
					</Column>
				</Maybe.Fallback>
			</Maybe>
		</S.TabWrapper>
	);
}
